export function shouldShowWorkspaceLoadingState({
  board,
  wallLoadError,
}: {
  board: unknown | null;
  wallLoadError: string | null;
}) {
  return !board && !wallLoadError;
}
